exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wrapper__g4rt {\n  height: 100%;\n  overflow: hidden; }\n\n.grid__1TqH {\n  padding-top: 20px; }\n", "", {"version":3,"sources":["/app/src/components/asset-library/src/components/asset-library/asset-grid.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EAIb,iBAAiB,EAClB;;AAED;EACE,kBAAkB,EACnB","file":"asset-grid.scss","sourcesContent":[".wrapper {\n  height: 100%;\n\n  // This is a workaround for an issue with react-virtualized AutoSizer that causes the scrollbars\n  // to flicker. https://github.com/bvaughn/react-virtualized/issues/773\n  overflow: hidden;\n}\n\n.grid {\n  padding-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "wrapper__g4rt",
	"grid": "grid__1TqH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/asset-library/asset-grid.scss
// module id = 956
// module chunks = 0